module.exports = __webpack_public_path__ + "assets/img/btn-detail-da77b223.png";